import {
  SHDivider,
  SHHtmlBlock,
  SHStack,
  SHTypography,
} from "@components/design-systems";
import SHRichTextEditorV2 from "@components/design-systems/sh-rich-text-editor-v2";
import {
  AnalysisSummaryDTO,
  RenderAnalysisSummaryItemProps,
} from "@models/platform-analysis/entities/steps/summary";
import { useTheme } from "@mui/material";
import { RootState } from "@redux/store";
import { memo } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";
import { AnalysisSummaryStaticValueConfigs } from "../../configs";

export const SummaryObjective = memo(
  ({
    disabled: sectionDisabled,
    name,
    userType,
    isReadOnly,
  }: RenderAnalysisSummaryItemProps) => {
    const { palette } = useTheme();

    const { control } = useFormContext<AnalysisSummaryDTO>();

    const storedData = useSelector(
      (state: RootState) =>
        state.platformAnalysis?.platformAnalysis?.summary?.objectives,
    );

    return (
      <SHStack width={"100%"} alignItems={"center"} justifyContent={"center"}>
        {storedData && isReadOnly && (
          <SHStack width={"100%"} gap={0.5}>
            <SHTypography variant="subtitle2">{name?.[userType]}</SHTypography>
            <SHDivider />
            <SHHtmlBlock
              content={storedData}
              placeholder={"Insert objectives"}
              color={palette.text.third}
            />
          </SHStack>
        )}

        {!isReadOnly && (
          <Controller
            control={control}
            name="objectives"
            render={({ field }) => (
              <SHRichTextEditorV2
                isDisabled={sectionDisabled}
                label={name?.[userType]}
                disabled={sectionDisabled}
                value={field.value || ""}
                placeholder="Insert objectives"
                onChange={field.onChange}
                maxCharacters={
                  AnalysisSummaryStaticValueConfigs.MaximumObjectivesCharacters
                }
                styledContainerSx={{
                  minHeight: "auto",
                  "& .editor-container": {
                    marginTop: 2,
                    marginBottom: 2,
                  },
                }}
              />
            )}
          />
        )}
      </SHStack>
    );
  },
);
